import React from "react";
import { motion } from "framer-motion";

const AreaItem = ({
  item,
  itemId,
  checked,
  handleAreas,
  marginStyle,
  handleClick,
  button,
}) => {
  return (
    <div className={`${marginStyle} flex-1 flex gap-2.5 items-center`}>
      <input
        type="checkbox"
        id={itemId}
        name={item.value}
        value={item.label}
        checked={checked}
        onChange={(e) => handleAreas(item, e.target.checked)}
        className="hidden"
      />
      <div
        className={`${
          checked
            ? "border border-themeSecondColor border-opacity-30"
            : "border border-[#E0E4ED]"
        } relative w-5 h-5 overflow-hidden rounded cursor-pointer flex items-center justify-center`}
        onClick={() => handleAreas(item, !checked)}
      >
        <motion.div
          className={`${
            checked ? "bg-[#F2D2B9] text-themeSecondColor" : "bg-transparent"
          } w-full h-full flex items-center justify-center transition-all`}
        >
          {checked && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-2.5 h-2.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          )}
        </motion.div>
      </div>
      {!button && (
        <label htmlFor={itemId} className="cursor-pointer">
          {item.label}
        </label>
      )}
      {button && !item.children && (
        <label htmlFor={itemId} className="cursor-pointer">
          {item.label}
        </label>
      )}
      {button && item.children && (
        <button
          onClick={(e) => {
            e.preventDefault();
            handleClick();
          }}
          className="cursor-pointer flex-1 text-left"
        >
          {item.label}
        </button>
      )}
    </div>
  );
};

export default AreaItem;
